import { Component, Input, OnInit } from '@angular/core';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import ProductHelper from 'src/app/helpers/product-helper';
import Board from 'src/app/model/product/board/board';
import { ProductTypes } from 'src/app/model/product/product-type';
import { Project } from 'src/app/model/project/project';
import { ProjectDisplayObservableService } from 'src/app/services/project-display-observable.service';
import { SubscriptionWithDestroyTriggerComponent } from 'src/app/subscription-helpers/subscription-with-destroy-trigger.component';

@Component({
  selector: 'product-price-summary',
  templateUrl: './product-price-summary.component.html',
  styleUrls: ['./product-price-summary.component.scss']
})
export class ProductPriceSummaryComponent
  extends SubscriptionWithDestroyTriggerComponent
  implements OnInit {
  @Input()
  project: Project;

  atLeastOneNonStandardPrice: boolean = false;
  atLeastOneRetailer: boolean = false;
  totalPrice: number = 0;

  constructor(
    private projectDisplayObservableService: ProjectDisplayObservableService
  ) {
    super();
  }

  ngOnInit(): void {
    this.calculateAtLeastOneRetailer();
    this.calculateAtLeastOneNonStandardPrice();
    this.calculateTotalPrice();

    const calculateSubTotalObservable = this.createObservableUntilDestroy(
      this.projectDisplayObservableService.getProductAddedSubscribable(),
      this.projectDisplayObservableService.getProductPlacementVariableChangedSubscribable(),
      this.projectDisplayObservableService.getProductSizeChangedSubscribable()
    );

    this.addSubscription(calculateSubTotalObservable, () => {
      this.calculateAtLeastOneNonStandardPrice();
      this.calculateTotalPrice();
    });

    this.addSubscription(
      this.projectDisplayObservableService.getProjectContactsChangedSubscribable(),
      () => {
        this.calculateAtLeastOneRetailer();
        this.calculateTotalPrice();
      }
    );
  }

  private calculateAtLeastOneRetailer(): void {
    this.atLeastOneRetailer =
      CollectionHelper.isPopulated(this.project.projectContacts) &&
      this.project.projectContacts.some(
        pc => pc.company != null && pc.company.isRetailer
      );
  }

  private calculateAtLeastOneNonStandardPrice(): void {
    this.atLeastOneNonStandardPrice = !CollectionHelper.isPopulated(
      this.project.products
    )
      ? false
      : this.project.products.some(p => {
          if (p.type !== ProductTypes.BOARD.value) {
            return true;
          }
          const board = <Board>p;
          return (
            CollectionHelper.isPopulated(board.boardParts) &&
            board.boardParts.some(bp => bp.signSize == null)
          );
        });
  }

  private calculateTotalPrice(): void {
    this.totalPrice = ProductHelper.getDefaultPriceTotalSum(
      this.project.products,
      this.atLeastOneRetailer
    );
  }
}
